export type TopUpAction =
    | { type: 'SET_AMOUNT'; payload: string }
    | { type: 'SET_ERROR'; payload: string }
    | { type: 'CLEAR_ERROR' }
    | { type: 'SUBMIT_START' }
    | { type: 'SUBMIT_SUCCESS' }
    | { type: 'RESET' };

export const topUpActions = {
    setAmount: (amount: string): TopUpAction => ({
        type: 'SET_AMOUNT',
        payload: amount,
    }),
    setError: (error: string): TopUpAction => ({
        type: 'SET_ERROR',
        payload: error,
    }),
    clearError: (): TopUpAction => ({
        type: 'CLEAR_ERROR',
    }),
    submitStart: (): TopUpAction => ({
        type: 'SUBMIT_START',
    }),
    submitSuccess: (): TopUpAction => ({
        type: 'SUBMIT_SUCCESS',
    }),
    reset: (): TopUpAction => ({
        type: 'RESET',
    }),
};